import { render } from "./OrderPage.vue?vue&type=template&id=482d40e1&scoped=true"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"

import "./OrderPage.vue?vue&type=style&index=0&id=482d40e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482d40e1"]])

export default __exports__